import { render } from "./ConfirmSizeOptions.vue?vue&type=template&id=204da826"
import script from "./ConfirmSizeOptions.vue?vue&type=script&lang=js"
export * from "./ConfirmSizeOptions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__